import CloudinaryProvider from './CloudinaryProvider'

export * from './CloudinaryProvider'
export default CloudinaryProvider
